import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Table } from '../../../../components/general/table';
import { asyncGetSurveyResponseLogs } from '../../../../../services/survey.service';
import { useSurveyResponseLogs } from './hook';
import { SurveyResponseLogsProps } from './props';

export const SurveyResponseLogs = ({
    historical: historicalProp,
    showHistorical,
    responseId,
}: SurveyResponseLogsProps = {}) => {
    const [historical, setHistorical] = useState<any[]>(historicalProp || []);
    const [loading, setLoading] = useState(!historicalProp);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    // Si se pasa historical como prop, usarlo directamente (modo embebido)
    const isEmbedded = showHistorical !== undefined;
    const dataToUse = isEmbedded ? historicalProp || [] : historical;

    const { columns, rows, detailDialog } = useSurveyResponseLogs({
        historical: dataToUse,
    });

    useEffect(() => {
        // Solo cargar logs si no está en modo embebido y hay un responseId
        if (!isEmbedded && responseId) {
            loadLogs();
        }
    }, [responseId, isEmbedded]);

    useEffect(() => {
        // Actualizar historical cuando cambia el prop
        if (isEmbedded && historicalProp) {
            setHistorical(historicalProp);
        }
    }, [historicalProp, isEmbedded]);

    const loadLogs = async () => {
        setLoading(true);
        try {
            const data = await asyncGetSurveyResponseLogs(responseId!);
            setHistorical(data);
        } catch (error) {
            console.error('Error loading logs:', error);
        } finally {
            setLoading(false);
        }
    };

    const handlePaginationChange = (newPagination: {
        page: number;
        pageSize: number;
    }) => {
        setPaginationModel(newPagination);
    };

    const paginatedRows = rows.slice(
        paginationModel.page * paginationModel.pageSize,
        (paginationModel.page + 1) * paginationModel.pageSize
    );

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {loading ? (
                        <div>Cargando historial...</div>
                    ) : (
                        <Table
                            columns={columns}
                            rows={paginatedRows}
                            rowCount={rows.length}
                            paginationModel={paginationModel}
                            onPaginationModelChange={handlePaginationChange}
                            pageSizeOptions={[10, 20, 50]}
                            disableRowSelectionOnClick
                        />
                    )}
                </Grid>
            </Grid>
            {detailDialog}
        </>
    );
};
